import { C1DrawerInner } from 'components/core/drawer/C1DrawerInner'
import { ReactNode } from 'react'

type InfoDrawerProps = {
    title: ReactNode
    content: ReactNode
}
export const InfoDrawer = ({ title, content }: InfoDrawerProps): React.ReactElement => {
    return <C1DrawerInner>
        <C1DrawerInner.Header>
            {title}
        </C1DrawerInner.Header>
        <C1DrawerInner.Content>
            {content}
        </C1DrawerInner.Content>
    </C1DrawerInner>
}
